import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, List, ListItem, Stack } from "@mui/material";
import MKTypography from "components/MKTypography";
import MKBox from "components/MKBox";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CBDivider from "components/CBDivider";

const ProductAccordion = ({ titles, descriptions }) => {
  const [expandedAccordion, setExpandedAccordion] = useState(false);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);
  };

  const AccordionBlock = ({ title, description, index, expanded, onChange, sx }) => (
    <Accordion
      key={index}
      expanded={expanded}
      onChange={onChange}
      sx={{
        background: "transparent",
        boxShadow: "none",
        width: "100%",
        "&:before": {
          display: "none",
        },
        ...sx,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index}-content`}
        id={`panel${index}-header`}
        sx={{
          border: "none",
          padding: 0,
          "&.Mui-expanded": {
            minHeight: "35px !important",
            maxHeight: "35px",
          },
        }}
      >
        <Stack direction={"row"} alignItems={"center"} spacing={2}>
          <MKBox
            component="img"
            sx={{ width: "32px" }}
            src="https://d3a0rs3velfrz.cloudfront.net/logos/almadelicButterFlyTransparentSm.webp"
            alt="Almadelic butterfly bullet point icon"
          />
          <MKTypography className="bullet-point-title" component="p" variant="body2">
            {title}
          </MKTypography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ paddingBlock: 0 }}>
        <CBDivider />
        <MKTypography className="bullet-point-description" component="p" variant="body2">
          {description}
        </MKTypography>
      </AccordionDetails>
    </Accordion>
  );

  return (
    <List>
      <ListItem sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start" }}>
        {titles.map((title, index) => (
          <AccordionBlock
            key={index}
            title={title}
            description={descriptions[index]}
            index={index}
            expanded={expandedAccordion === index}
            onChange={handleAccordionChange(index)}
          />
        ))}
        <AccordionBlock
          sx={{ marginBottom: "1rem" }}
          title="Earn Points, Pay Less Next Time"
          description="Build up reward points through purchases and activities, then apply them as payment credits to lower your costs on future orders."
        />
      </ListItem>
    </List>
  );
};

export default ProductAccordion;
